import { Box } from '@mui/material';
import InfiniteScroll from 'react-swr-infinite-scroll';

import { LoadingInfiniteScroll } from 'src/components/atoms/loading';
import CoursesCard from 'src/components/molecules/courseCard';
import { useWindowSize } from 'src/helpers/use';
import { ICategory, ICoursesPagination } from 'src/interfaces';

type Props = {
  courseApiResponse: any;
  loadMoreCount: number;
  learningPathId?: number;
  learningPathCategory?: ICategory;
  courseCount?: number;
};

const CourseList = ({ courseApiResponse, loadMoreCount, learningPathId, learningPathCategory, courseCount }: Props) => {
  const { width } = useWindowSize();

  const isReachingEnd = (response: any) => {
    const responseData = response.data;
    if (responseData) {
      return responseData[responseData.length - 1].data.items.length < loadMoreCount;
    }
    return false;
  };

  return (
    <InfiniteScroll swr={courseApiResponse} loadingIndicator={<LoadingInfiniteScroll />} isReachingEnd={isReachingEnd}>
      {(response: { data: ICoursesPagination }) => (
        <Box sx={{ mt: width! < 1150 ? 2 : 0 }}>
          <CoursesCard
            courses={response?.data.items}
            learningPathId={learningPathId}
            learningPathCategory={learningPathCategory}
            courseCount={courseCount}
          />
        </Box>
      )}
    </InfiniteScroll>
  );
};

export default CourseList;
